import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

export const getAllCategory = async () => {
  let request = await axios({
    method: "GET",
    url: endpoints.common.GET_ALL_CATEGORY,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const singleImageUpload = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.common.SINGLE_FILE_UPLOAD,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const multipleImageUpload = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.common.MULTIPLE_FILE_UPLOAD,
    headers: {
      Authorization: getAuthToken(),
    },
    data: data,
  });
  return request;
};

export const getDonationDropdown = async () => {
  let request = await axios({
    method: "GET",
    url: endpoints.common.DONATION_DROPDOWN,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const getInventoryDropdown = () => {
  let request = axios({
    method: "GET",
    url: endpoints.common.INVENTORY_DROPDOWN,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const validateToken = () => {
  let request = axios({
    method: "GET",
    url: endpoints.common.VALIDATE_TOKEN,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

export const getActionLists = () => {
  let request = axios({
    method: "GET",
    url: endpoints.common.ACTIONLIST,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};
